<template>
  <router-link class="user-card" :title="user.handle" :to="`/org/${user.handle}`">
    <img :src="profileImage"
      @error="setDefaultImage"
      
     alt="Company logo"
    class="logo" />
    <div class="details">
      <div class="company" style="text-decoration:none;color:var(--foreground);">
        
        <div class="user-title">
          {{ user.fullName }} 
        </div>
        <div class="handle">
          {{ user.handle }}
        </div>
    </div >
      <div class="type user-detail" :class="user.totalVacancies > 0 ? 'green':'grey'">
       <BriefcaseJobIcon class="job-icon"/> <div class="detail">{{ vacanciesLabel }}</div>
      </div>
    
    </div>
  </router-link>
</template>

<script>
import BriefcaseJobIcon from '../IconComponents/BriefcaseJobIcon.vue';
export default {
  components:{
    BriefcaseJobIcon
  },
  data(){
    return{
      url:process.env.VUE_APP_API_URL
    }
  },
//   mounted(){
//     console.log(this.url, this.user.userId);
//   },
  computed:{
    profileImage(){
      if (!this.user.userId) {
        return require('@/assets/images/profile_picture.png');
      } 
      return this.url + 'Auth/Image/' + this.user.userId;
    },
    vacanciesLabel(){
        if(this.user.totalVacancies <= 0){
            return "No Open Positions";
        }else if(this.user.totalVacancies == 1){
            return `${this.user.totalVacancies} Open Position`;
        }else{
            return `${this.user.totalVacancies} Open Positions`;
        }
    }
  },
  methods: {
    setDefaultImage(event) {
      event.target.src = require('@/assets/images/profile_picture.png');
    },
     getListItem(){
      return this.user;
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    }
    
  }
 
};
</script>
<style scoped>

.user-detail{
  display: flex;
  align-items: center;
  color:var(--darkgrey3);
  margin-top:-0.2rem;
}

.detail{
  font-family: var(--body-font);
  font-size:0.8rem;
}

.user-icon{
  height:1rem;
  margin-right:0.4rem;
  margin-top:-0.2rem;
  color:var(--darkgrey3);
}

.user-card {
  display: flex;
  align-items: flex-start;
  padding: 0.7rem;
  border-radius: 12px;
  background: var(--list-item);
  margin-bottom: 0.5rem;
  cursor: pointer;
  color:var(--foreground);
  text-decoration: none;
}

.logo {
  width: 60px;
  height: 60px;
  margin-right: 1rem;
  border-radius: 4px;
  object-fit: cover;
}

.details{
  margin-top:-0.3rem;
}

.details h3 {
  margin: 0;
  font-size: 1.1rem;
}

.description{
  white-space: pre-line;
}

.company {
  display:grid;
  grid-template-rows:auto auto;
}

.company:hover {
  text-decoration:underline!important;
}

.handle{
  font-family: var(--heading-font-bold);
  font-size:0.8rem;
  margin-bottom:0.4rem;
  white-space:wrap;
  color:var(--darkgrey3);
}

.user-title{
   font-family: var(--heading-font-bold);
   font-size:1.3rem;
   color:var(--user-title);
   white-space:nowrap;
   overflow-x: hidden;
   text-overflow: ellipsis;
}

.location, .type, .closing-date{
  font-family: var(--heading-font2-regular);
}

.job-icon{
    height:0.9rem;
    margin-right:0.3rem;
}

.grey{
    color:var(--darkgrey3)!important;
  }

  .green{
    color:var(--green)!important;
  }

/* Mobile layout */
@media (max-width: 768px) {
  .details {
    width: 100%;
    margin-left: 0.3rem;
    margin-top:-0.2rem;
  }

  .details h3 {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .logo {
    margin-right: 0.5rem;
    margin-bottom:0.7rem;
  }

  .user-card > .logo,
  .user-card > .details h3 {
    display: inline-block;
    vertical-align: middle;
  }

  .description {
    display: block;
    margin-top: 0.4rem;
    width: 100%;
  }

  .user-card {
    padding: 0.7em;
    background: var(--list-item);
    margin-bottom: 0.7rem;
  }

  .company {
    font-size:1.1rem;
  }

  .location, .type, .closing-date{
    color:var(--text-grey);
    font-size:0.9rem;
  }

  .user-title{   
     font-size:1rem;
  }

  
}
</style>